export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/groups/groups-form.js